import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import TypographyStyles from './typographyStyles';

const Block = props => {
  return <TypographyStyles.BlockStyles {...props}>{props.children}</TypographyStyles.BlockStyles>;
};

Block.propTypes = {
  children: PropTypes.node,
};

const Paragraph = props => {
  return (
    <TypographyStyles.ParagraphStyles {...props}>{props.children}</TypographyStyles.ParagraphStyles>
  );
};

Paragraph.propTypes = {
  children: PropTypes.node,
};

const Text = props => {
  switch (props.type) {
    case 'marked':
      return (
        <TypographyStyles.TextStyles as="mark" {...props}>
          {props.children}
        </TypographyStyles.TextStyles>
      );
    case 'deleted':
      return (
        <TypographyStyles.TextStyles as="del" {...props}>
          {props.children}
        </TypographyStyles.TextStyles>
      );
    case 'strong':
      return (
        <TypographyStyles.TextStyles as="strong" {...props}>
          {props.children}
        </TypographyStyles.TextStyles>
      );
    case 'underlined':
      return (
        <TypographyStyles.TextStyles as="u" {...props}>
          {props.children}
        </TypographyStyles.TextStyles>
      );
    case 'small':
      return (
        <TypographyStyles.TextStyles as="small" {...props}>
          {props.children}
        </TypographyStyles.TextStyles>
      );
    default:
      return <TypographyStyles.TextStyles {...props}>{props.children}</TypographyStyles.TextStyles>;
  }
};

Text.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
};

Text.defaultProps = {
  type: undefined,
};

const Link = forwardRef((props, ref) => {
  return (
    <TypographyStyles.LinkStyles ref={ref} {...props}>
      {props.children}
    </TypographyStyles.LinkStyles>
  );
});

Link.propTypes = {
  children: PropTypes.node,
};

const Heading = props => {
  return (
    <TypographyStyles.HeadingStyles as={`h${props.size}`} {...props}>
      {props.children}
    </TypographyStyles.HeadingStyles>
  );
};

Heading.propTypes = {
  collapsibleControllerOpened: PropTypes.bool,
  size: PropTypes.number,
  children: PropTypes.node,
};

Heading.defaultProps = {
  collapsibleControllerOpened: undefined,
  size: 1,
};

const Image = props => {
  return <TypographyStyles.ImageStyles {...props} />;
};

export default {
  Block,
  Heading,
  Link,
  Paragraph,
  Text,
  Image,
};
